

export default class {
    constructor($el, windowPal) {
        this.$ = $el;
        this.windowPal = windowPal;
        this.$close = $el.find('.-close');
        this.isOpen = false;
        // console.log('MobileNav', $el[0]);
        let sel = $el.data('mobile-nav');
        $(sel).click(()=>{
            this.click();
        });
        // console.log(this.$close[0]);
        this.$close.click(()=>{
            this.close();
        });
        // this.open(); /* temp */
        let $telLink = $el.find('[href*="tel"]').parent(),
            $contactLink = $el.find('[href="#contact"]').parent();
        // console.log($telLink[0], $telLink.length, $contactLink[0], $contactLink.length);
        $contactLink.after($telLink).remove();
    }
    click() {
        // console.log('click');
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }
    open() {
        this.isOpen = true;
        this.$.css('display', 'block');
        setTimeout(()=>{
            this.$.addClass('-open');
        }, 10);
    }
    close() {
        // console.log('close()');
        this.isOpen = false;
        this.$.removeClass('-open');
        setTimeout(()=>{
            this.$.css('display', 'none');
        }, 500);
    }
}


// WEBPACK FOOTER //
// ./scripts/lib/MobileNav.js